import React, {useState} from 'react';
import { Select, Divider, Button, Icon } from 'antd';

const { Option } = Select;

export default function SelectBasico(props){
    const {idProp, dados, onChange} = props;
    
    return(<>
        <Select
      {...props}
      showSearch
      allowClear
      style={{ width: '100%'}}
      optionFilterProp="children"
      placeholder={props.placeholder}
      value={ idProp }
      onChange={onChange}
      filterOption={(input, option) => option.props.children ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 : false}
      >
      {(dados || []).map(item => (
          <Option key={item.id} value={item.id}>{item.nome}</Option>
      ))}
  </Select>

   </> )
}